import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import state from './state'

import { Map, View } from 'ol';

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'


const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});


export default store


// WEBPACK FOOTER //
// ./src/store/index.js